// WebDevelopment.tsx

import React from "react";
import { motion } from "framer-motion";
import Img from "../../assets/Internship/web_development_Img.png";
import logo1 from "../../assets/Internship/Data_Science_logo.png";
import logo2 from "../../assets/Internship/Data_Analytics_logo.jpg";
import logo3 from "../../assets/Internship/Machine_Learning_Logo.png";
import logo4 from "../../assets/Internship/Power_BI_logo.png";
import logo5 from "../../assets/Internship/marketing_logo.png";
import logo6 from "../../assets/Internship/React_logo.png";
import logo7 from "../../assets/Internship/Mern_logo.png";
import logo8 from "../../assets/Internship/Java_logo.png";
import logo9 from "../../assets/Internship/Python_logo.png";
import logo10 from "../../assets/Internship/IOT_logo.png";
import logo11 from "../../assets/Internship/Robotics_logo.jpg";
import logo12 from "../../assets/Internship/AI_logo.avif";

const WebDevelopment = () => {
  return (
    <div className="bg-gradient-to-br from-blue-900 via-blue-900 to-black text-white min-h-screen">
      {/* Hero Section */}
      <section className="px-6 md:px-20 py-24 relative overflow-hidden h-[450px]"> {/* Increased py- */}
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center">
          {/* Left Side Text */}
          <motion.div
            className="md:w-1/2 mb-12 md:mb-0"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <h1 className="text-3xl md:text-4xl font-extrabold leading-tight mb-6 text-white">
              Build Beautiful Websites with Modern Web Development
            </h1>
            <p className="text-lg text-gray-300 mb-8">
              We create high-performance websites that look stunning and deliver results. Let's turn your ideas into reality!
            </p>
            <button className="bg-orange-600 hover:bg-orange-500 text-white font-semibold py-3 px-6 rounded-2xl transition-all duration-300 shadow-lg">
              Get Started
            </button>
          </motion.div>

         {/* Right Side Image */}
<motion.div
  className="md:w-1/2 flex justify-center mt-[-60px]"
  initial={{ opacity: 0, x: 50 }}
  animate={{ opacity: 1, x: 0 }}
  transition={{ duration: 1 }}
>
  <img
    src={Img}
    alt="Web Development"
    className="rounded-xl w-full max-w-md shadow-2xl"
  />
</motion.div>
</div>
      </section>



    {/* Popular Courses Section */}
<section className="px-6 md:px-20 py-24 bg-gray-300 text-orange-600">
  <h2 className="text-5xl font-bold text-center mb-10">Popular Courses</h2>
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-6">
    {/* Data Science */}
    <div className="flex flex-col items-center p-4 bg-white rounded-xl shadow-lg hover:scale-105 transition-transform">
      <img src={logo1} alt="Data Science Icon" className="w-16 h-16 mb-2"/>
      <h3 className="text-lg font-semibold text-center">Data Science</h3>
      <a href="/courses/data-science" className="mt-4 bg-orange-600 hover:bg-orange-700 text-white text-sm py-2 px-4 rounded-xl transition-all duration-300">View Course</a>
    </div>
    {/* Data Analytics */}
    <div className="flex flex-col items-center p-4 bg-white rounded-xl shadow-lg hover:scale-105 transition-transform">
      <img src={logo2} alt="Data Analytics Icon" className="w-16 h-16 mb-2"/>
      <h3 className="text-lg font-semibold text-center">Data Analytics</h3>
      <a href="/courses/data-analytics" className="mt-4 bg-orange-600 hover:bg-orange-700 text-white text-sm py-2 px-4 rounded-xl transition-all duration-300">View Course</a>
    </div>
    {/* Machine Learning */}
    <div className="flex flex-col items-center p-4 bg-white rounded-xl shadow-lg hover:scale-105 transition-transform">
      <img src={logo3} alt="Machine Learning Icon" className="w-16 h-16 mb-2"/>
      <h3 className="text-lg font-semibold text-center">Machine Learning</h3>
      <a href="/courses/machine-learning" className="mt-4 bg-orange-600 hover:bg-orange-700 text-white text-sm py-2 px-4 rounded-xl transition-all duration-300">View Course</a>
    </div>
    {/* Power BI Training */}
    <div className="flex flex-col items-center p-4 bg-white rounded-xl shadow-lg hover:scale-105 transition-transform">
      <img src={logo4} alt="Power BI Icon" className="w-16 h-16 mb-2"/>
      <h3 className="text-lg font-semibold text-center">Power BI Training</h3>
      <a href="/courses/power-bi" className="mt-4 bg-orange-600 hover:bg-orange-700 text-white text-sm py-2 px-4 rounded-xl transition-all duration-300">View Course</a>
    </div>
    {/* Digital Marketing */}
    <div className="flex flex-col items-center p-4 bg-white rounded-xl shadow-lg hover:scale-105 transition-transform">
      <img src={logo5} alt="Digital Marketing Icon" className="w-16 h-16 mb-2"/>
      <h3 className="text-lg font-semibold text-center">Digital Marketing</h3>
      <a href="/courses/digital-marketing" className="mt-4 bg-orange-600 hover:bg-orange-700 text-white text-sm py-2 px-4 rounded-xl transition-all duration-300">View Course</a>
    </div>
    {/* ReactJS Training */}
    <div className="flex flex-col items-center p-4 bg-white rounded-xl shadow-lg hover:scale-105 transition-transform">
      <img src={logo6} alt="ReactJS Icon" className="w-16 h-16 mb-2"/>
      <h3 className="text-lg font-semibold text-center">ReactJS Training</h3>
      <a href="/courses/reactjs-training" className="mt-4 bg-orange-600 hover:bg-orange-700 text-white text-sm py-2 px-4 rounded-xl transition-all duration-300">View Course</a>
    </div>
    {/* MERN Full Stack */}
    <div className="flex flex-col items-center p-4 bg-white rounded-xl shadow-lg hover:scale-105 transition-transform">
      <img src={logo7} alt="MERN Stack Icon" className="w-16 h-16 mb-2"/>
      <h3 className="text-lg font-semibold text-center">MERN Full Stack</h3>
      <a href="/courses/mern-fullstack" className="mt-4 bg-orange-600 hover:bg-orange-700 text-white text-sm py-2 px-4 rounded-xl transition-all duration-300">View Course</a>
    </div>
    {/* Java Full Stack */}
    <div className="flex flex-col items-center p-4 bg-white rounded-xl shadow-lg hover:scale-105 transition-transform">
      <img src={logo8} alt="Java Icon" className="w-16 h-16 mb-2"/>
      <h3 className="text-lg font-semibold text-center">Java Full Stack</h3>
      <a href="/courses/java-fullstack" className="mt-4 bg-orange-600 hover:bg-orange-700 text-white text-sm py-2 px-4 rounded-xl transition-all duration-300">View Course</a>
    </div>
    {/* Python Full Stack */}
    <div className="flex flex-col items-center p-4 bg-white rounded-xl shadow-lg hover:scale-105 transition-transform">
      <img src={logo9} alt="Python Icon" className="w-26 h-16 mb-2"/>
      <h3 className="text-lg font-semibold text-center">Python Full Stack</h3>
      <a href="/courses/python-fullstack" className="mt-4 bg-orange-600 hover:bg-orange-700 text-white text-sm py-2 px-4 rounded-xl transition-all duration-300">View Course</a>
    </div>
    {/* IoT Training */}
    <div className="flex flex-col items-center p-4 bg-white rounded-xl shadow-lg hover:scale-105 transition-transform">
      <img src={logo10} alt="IoT Icon" className="w-16 h-16 mb-2"/>
      <h3 className="text-lg font-semibold text-center">IoT Training</h3>
      <a href="/courses/iot-training" className="mt-4 bg-orange-600 hover:bg-orange-700 text-white text-sm py-2 px-4 rounded-xl transition-all duration-300">View Course</a>
    </div>
    {/* Robotics */}
    <div className="flex flex-col items-center p-4 bg-white rounded-xl shadow-lg hover:scale-105 transition-transform">
      <img src={logo11} alt="Robotics Icon" className="w-16 h-16 mb-2"/>
      <h3 className="text-lg font-semibold text-center">Robotics</h3>
      <a href="/courses/robotics" className="mt-4 bg-orange-600 hover:bg-orange-700 text-white text-sm py-2 px-4 rounded-xl transition-all duration-300">View Course</a>
    </div>
    {/* AI Training */}
    <div className="flex flex-col items-center p-4 bg-white rounded-xl shadow-lg hover:scale-105 transition-transform">
      <img src={logo12} alt="AI Icon" className="w-16 h-16 mb-2"/>
      <h3 className="text-lg font-semibold text-center">AI Training</h3>
      <a href="/courses/ai-training" className="mt-4 bg-orange-600 hover:bg-orange-700 text-white text-sm py-2 px-4 rounded-xl transition-all duration-300">View Course</a>
    </div>
  </div>
</section>

      {/* Why Choose Us Section */}
      <section className="px-6 md:px-20 py-24 bg-white text-orange-600"> {/* Increased py- */}
        <h2 className="text-3xl font-bold text-center mb-10">Why Choose us ?</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Hybrid Mode Class */}
          <div className="flex items-start p-6 bg-gray-800 rounded-xl shadow-lg">
            <img src="/icons/hybrid-mode.png" alt="Hybrid Mode Icon" className="w-12 h-12 mr-4"/> {/* Placeholder icon */}
            <div>
              <h3 className="text-xl font-semibold mb-2">Hybrid Mode Class</h3>
              <p className="text-gray-300">Learn flexibly with combined online and offline classroom training sessions.</p>
            </div>
          </div>
          {/* Internship Certificate */}
          <div className="flex items-start p-6 bg-gray-800 rounded-xl shadow-lg">
            <img src="/icons/certificate.png" alt="Certificate Icon" className="w-12 h-12 mr-4"/> {/* Placeholder icon */}
            <div>
              <h3 className="text-xl font-semibold mb-2">Internship Certificate</h3>
              <p className="text-gray-300">Receive an internship certificate for hands-on industry project experience.</p>
            </div>
          </div>
          {/* 100% Placement Assistance */}
          <div className="flex items-start p-6 bg-gray-800 rounded-xl shadow-lg">
            <img src="/icons/placement.png" alt="Placement Icon" className="w-12 h-12 mr-4"/> {/* Placeholder icon */}
            <div>
              <h3 className="text-xl font-semibold mb-2">100% Placement Assistance</h3>
              <p className="text-gray-300">Complete placement support provided until you secure a suitable job.</p>
            </div>
          </div>
          {/* CV Building & ATS Score */}
          <div className="flex items-start p-6 bg-gray-800 rounded-xl shadow-lg">
            <img src="/icons/cv-building.png" alt="CV Icon" className="w-12 h-12 mr-4"/> {/* Placeholder icon */}
            <div>
              <h3 className="text-xl font-semibold mb-2">CV Building & ATS Score</h3>
              <p className="text-gray-300">Optimize your resume for ATS and improve shortlisting chances significantly.</p>
            </div>
          </div>
          {/* Mock Interviews */}
          <div className="flex items-start p-6 bg-gray-800 rounded-xl shadow-lg">
            <img src="/icons/mock-interview.png" alt="Mock Interview Icon" className="w-12 h-12 mr-4"/> {/* Placeholder icon */}
            <div>
              <h3 className="text-xl font-semibold mb-2">Mock Interviews</h3>
              <p className="text-gray-300">Practice with mock interviews to boost real interview performance confidence.</p>
            </div>
          </div>
          {/* 15 Students Per Batch */}
          <div className="flex items-start p-6 bg-gray-800 rounded-xl shadow-lg">
            <img src="/icons/small-batch.png" alt="Small Batch Icon" className="w-12 h-12 mr-4"/> {/* Placeholder icon */}
            <div>
              <h3 className="text-xl font-semibold mb-2">15 Students Per Batch</h3>
              <p className="text-gray-300">Small batches ensure personalized attention and better student-teacher interaction.</p>
            </div>
          </div>
        </div>
      </section>

       

      {/* Our Achievements Section */}
      <section className="px-6 md:px-20 py-24 bg-gray-900 text-white"> {/* Increased py- */}
        <h2 className="text-3xl font-bold text-center mb-10">Our Achievements</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Each div represents an image container */}
          <div className="relative group rounded-xl overflow-hidden shadow-lg aspect-w-4 aspect-h-3">
            <img src="/achievements/achievement1.jpg" alt="Achievement 1" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"/>
          </div>
          <div className="relative group rounded-xl overflow-hidden shadow-lg aspect-w-4 aspect-h-3">
            <img src="/achievements/achievement2.jpg" alt="Achievement 2" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"/>
          </div>
          <div className="relative group rounded-xl overflow-hidden shadow-lg aspect-w-4 aspect-h-3">
            <img src="/achievements/achievement3.jpg" alt="Achievement 3" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"/>
          </div>
          <div className="relative group rounded-xl overflow-hidden shadow-lg aspect-w-4 aspect-h-3">
            <img src="/achievements/achievement4.jpg" alt="Achievement 4" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"/>
          </div>
          <div className="relative group rounded-xl overflow-hidden shadow-lg aspect-w-4 aspect-h-3">
            <img src="/achievements/achievement5.jpg" alt="Achievement 5" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"/>
          </div>
          <div className="relative group rounded-xl overflow-hidden shadow-lg aspect-w-4 aspect-h-3">
            <img src="/achievements/achievement6.jpg" alt="Achievement 6" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"/>
          </div>
          <div className="relative group rounded-xl overflow-hidden shadow-lg aspect-w-4 aspect-h-3">
            <img src="/achievements/achievement7.jpg" alt="Achievement 7" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"/>
          </div>
          <div className="relative group rounded-xl overflow-hidden shadow-lg aspect-w-4 aspect-h-3">
            <img src="/achievements/achievement8.jpg" alt="Achievement 8" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"/>
          </div>
        </div>
        <div className="text-center mt-10">
          <button className="bg-pink-600 hover:bg-pink-700 text-white font-semibold py-3 px-8 rounded-2xl transition-all duration-300 shadow-lg">
            Explore More
          </button>
        </div>
      </section>
    </div>
  );
};

export default WebDevelopment;